import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { navigate } from "../../../store/navigation/operations";
import moment from "moment";
import { NonIdealState, Button, InputGroup } from "@blueprintjs/core";
import { Send } from "@material-ui/icons/";

import { fetchMessages, fetchConversations, sendMessage } from "../../../store/messaging/operations";
import { getMessages, isLoadingMessages, getConversation } from "../../../store/messaging/selectors";
import { loggedInUserGuid } from "../../../store/iam/selectors";
import Moment from "react-moment";
import { Translate, I18n } from "react-redux-i18n";
import LoadingIndicator from "../../../components/LoadingIndicator";
import { UserImage, UserName } from "../User";
import CircleImage from "../../../components/Image/CircleImage";
import { isLoggedIn } from "../../../store/iam/selectors";

export class Conversation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message_to_send: "",
      show_loader: true,
    };
    this.chatWindow = React.createRef();
    this.intervalId = undefined;
    this.submitMessageForm = this.submitMessageForm.bind(this);
    this.updateMessageValue = this.updateMessageValue.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isLoggedIn !== prevProps.isLoggedIn) {
      this.init();
    }
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.init();
    }
  }

  init = () => {
    let fetching_conversation = this.props.fetchConversations();
    let fetching_messages = this.props.fetchMessages(this.props.conversationGuid);

    Promise.all([fetching_conversation, fetching_messages]).then((_) => {
      this.setState({ show_loader: false });
    });

    if (!this.intervalId) {
      this.intervalId = setInterval(this.fetchMessages, 5000);
    }
  };

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  fetchMessages = () => {
    this.props.fetchMessages(this.props.conversationGuid);
  };

  updateMessageValue(e) {
    this.setState({ message_to_send: e.target.value });
  }

  // componentDidUpdate(prevProps){   //TODO: implement scroll to bottom
  //     if(this.chatWindow.current && this.props.messages.length !== prevProps.messages.length){
  //       this.chatWindow.current.scrollTo(0, this.chatWindow.current.scrollHeight);
  //     }
  // }

  submitMessageForm(e) {
    e.preventDefault();
    if (this.state.message_to_send) {
      this.props.sendMessage(this.props.conversationGuid, this.state.message_to_send);
      this.setState({ message_to_send: "" });
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.includeHeader && (
          <div className="header">
            <Button
              intent="primary"
              onClick={(_) => this.props.navigate("/messages")}
              className="primary-ghost small"
              icon="arrow-left"
            />
            <div className="context">
              {this.props.conversation["is_circle"] && (
                <div className="image user-avatar size-44">
                  <CircleImage
                    size="small"
                    src={this.props.conversation["t_url"]}
                    alt={this.props.conversation["title"]}
                  />
                </div>
              )}
              <h1>{this.props.conversation["title"]}</h1>
            </div>
          </div>
        )}
        <div className="chat-wrapper">
          {this.state.show_loader && <LoadingIndicator />}
          {this.props.messages.length === 0 && !this.state.show_loader && (
            <div className="chat-items no-content">
              <NonIdealState
                icon="chat"
                title={I18n.t("messages.title")}
                description={I18n.t("messages.write_first_message")}
              />
            </div>
          )}
          {this.props.messages.length > 0 && (
            <div className="chat-items" ref={this.chatWindow}>
              {this.props.messages.map((message) => {
                const sentByMe = message["sender"] === this.props.myGuid;
                const chatElementClass = sentByMe ? "chat-element sent-by-me" : "chat-element";
                return (
                  <div className={chatElementClass} key={message["c_at"]}>
                    {!sentByMe && <UserImage userGuid={message["sender"]} />}

                    <div className="message">
                      {!sentByMe && <UserName userGuid={message["sender"]} />}
                      <div className="text">{message["content"]}</div>
                      <div className="timestamp">
                        <Moment locale={this.props.locale} from={moment().utc().format("YYYY-MM-DD HH:mm")} ago>
                          {moment(message["c_at"]).format("YYYY-MM-DD HH:mm")}
                        </Moment>
                        <Translate value="expenses.ago" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="sticky-bottom">
          <form onSubmit={this.submitMessageForm}>
            <InputGroup
              onChange={this.updateMessageValue}
              type="text"
              placeholder={I18n.t("messages.message_input_placeholder")}
              fill={true}
              value={this.state.message_to_send}
              className="no-icon has-button bp3-round primary-button"
              rightElement={
                <Button onClick={this.submitMessageForm} className="input-button right send-message">
                  <Send className="icon" />
                </Button>
              }
            />
          </form>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isLoggedIn: isLoggedIn(state),
    loading: isLoadingMessages(state, ownProps.conversationGuid),
    messages: getMessages(state, ownProps.conversationGuid),
    conversation: getConversation(state, ownProps.conversationGuid),
    myGuid: loggedInUserGuid(state),
    locale: state.i18n.locale,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchMessages: (conversationGuid) => {
    return dispatch(fetchMessages(conversationGuid));
  },
  fetchConversations: (_) => {
    return dispatch(fetchConversations());
  },
  sendMessage: (conversation_guid, message) => dispatch(sendMessage(conversation_guid, message)),
  navigate: (to) => dispatch(navigate(to)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Conversation);
